import React, { useState } from 'react';

import './slider.css';
import slide1 from './slide (1).jpg';
import slide2 from './slide (2).jpg';
import slide3 from './slide (3).jpg';
import slide4 from './slide (4).jpg';
import slide5 from './slide (5).jpg';
import slide6 from './slide (6).jpg';
import slide7 from './slide (7).jpg';
import slide8 from './slide (8).jpg';
import slide9 from './slide (8).jpg';
import slide10 from './slide (10).jpg';

import slide1Mobile from './slide-mobile (1).jpg';
import slide2Mobile from './slide-mobile (2).jpg';
import slide3Mobile from './slide-mobile (3).jpg';
import slide4Mobile from './slide-mobile (4).jpg';
import slide5Mobile from './slide-mobile (5).jpg';
import slide6Mobile from './slide-mobile (6).jpg';
import slide7Mobile from './slide-mobile (7).jpg';
import slide8Mobile from './slide-mobile (8).jpg';
import slide9Mobile from './slide-mobile (8).jpg';
import slide10Mobile from './slide-mobile (10).jpg';

import { Logo } from './../Logo/Logo';
import { Modal } from './../Modal/Modal';

export const Slider = () => {
	const [sliderShowing, setSlider] = useState(1);
	const [showModal, setModal] = useState(null);

	const onPrevClick = () => {
		if (sliderShowing === 1) {
			setSlider(10);
			return;
		}
		setSlider(sliderShowing - 1);
	}

	const onNextClick = () => {
		if (sliderShowing === 10) {
			setSlider(1);
			return;
		}
		setSlider(sliderShowing + 1);
	};

	return (
	    <div className="slider vertical pt-5">
			<div className={`slide ${sliderShowing === 1 ? 'slide-active vertical' : null} text-center`}>
	   			<img src={slide1} alt="Slider A lo Venezolano" className="slider-logo d-block mx-auto mb-4 only-desktop"/>
	   			<img src={slide1Mobile} alt="Slider A lo Venezolano" className="slider-logo d-block mx-auto mb-4 only-mobile"/>
	   		</div>
	   		<div className={`slide ${sliderShowing === 2 ? 'slide-active vertical' : null} text-center`}>
	   			<img src={slide2} alt="Slider A lo Venezolano" className="slider-logo d-block mx-auto mb-4 only-desktop"/>
	   			<img src={slide2Mobile} alt="Slider A lo Venezolano" className="slider-logo d-block mx-auto mb-4 only-mobile"/>
	   		</div>
	   		<div className={`slide ${sliderShowing === 3 ? 'slide-active vertical' : null} text-center`}>
	   			<img src={slide3} alt="Slider A lo Venezolano" className="slider-logo d-block mx-auto mb-4 only-desktop"/>
	   			<img src={slide3Mobile} alt="Slider A lo Venezolano" className="slider-logo d-block mx-auto mb-4 only-mobile"/>
	   		</div>
	   		<div className={`slide ${sliderShowing === 4 ? 'slide-active vertical' : null} text-center`}>
	   			<img src={slide4} alt="Slider A lo Venezolano" className="slider-logo d-block mx-auto mb-4 only-desktop"/>
	   			<img src={slide4Mobile} alt="Slider A lo Venezolano" className="slider-logo d-block mx-auto mb-4 only-mobile"/>
	   		</div>
	   		<div className={`slide ${sliderShowing === 5 ? 'slide-active vertical' : null} text-center`}>
	   			<img src={slide5} alt="Slider A lo Venezolano" className="slider-logo d-block mx-auto mb-4 only-desktop"/>
	   			<img src={slide5Mobile} alt="Slider A lo Venezolano" className="slider-logo d-block mx-auto mb-4 only-mobile"/>
	   		</div>
	   		<div className={`slide ${sliderShowing === 6 ? 'slide-active vertical' : null} text-center`}>
	   			<img src={slide6} alt="Slider A lo Venezolano" className="slider-logo d-block mx-auto mb-4 only-desktop"/>
	   			<img src={slide6Mobile} alt="Slider A lo Venezolano" className="slider-logo d-block mx-auto mb-4 only-mobile"/>
	   		</div>
	   		<div className={`slide ${sliderShowing === 7 ? 'slide-active vertical' : null} text-center`}>
	   			<img src={slide7} alt="Slider A lo Venezolano" className="slider-logo d-block mx-auto mb-4 only-desktop"/>
	   			<img src={slide7Mobile} alt="Slider A lo Venezolano" className="slider-logo d-block mx-auto mb-4 only-mobile"/>
	   		</div>
	   		<div className={`slide ${sliderShowing === 8 ? 'slide-active vertical' : null} text-center`}>
	   			<img src={slide8} alt="Slider A lo Venezolano" className="slider-logo d-block mx-auto mb-4 only-desktop"/>
	   			<img src={slide8Mobile} alt="Slider A lo Venezolano" className="slider-logo d-block mx-auto mb-4 only-mobile"/>
	   		</div>
	   		<div className={`slide ${sliderShowing === 9 ? 'slide-active vertical' : null} text-center`}>
	   			<img src={slide9} alt="Slider A lo Venezolano" className="slider-logo d-block mx-auto mb-4 only-desktop"/>
	   			<img src={slide9Mobile} alt="Slider A lo Venezolano" className="slider-logo d-block mx-auto mb-4 only-mobile"/>
	   		</div>
	   		<div className={`slide ${sliderShowing === 10 ? 'slide-active vertical' : null} text-center`}>
	   			<img src={slide10} alt="Slider A lo Venezolano" className="slider-logo d-block mx-auto mb-4 only-desktop"/>
	   			<img src={slide10Mobile} alt="Slider A lo Venezolano" className="slider-logo d-block mx-auto mb-4 only-mobile"/>
	   		</div>
	   		<div className="mission-buttons">
	   			<button onClick={() => setModal("mission")}>Misión</button>
	   			<button onClick={() => setModal("vision")}>Visión</button>
	   		</div>
	   		{
	   			showModal && 
	   			<Modal onClose={() => setModal(null)}>
	   				<Logo/>
	   				<h1>
	   					{
	   						showModal === "mission" ? 'Misión' :'Visión'
	   					}
	   				</h1>
	   				<p>
	   					{
	   						showModal === "mission" ? 
	   						'Nos enfocamos en fabricar y distribuir productos reutilizables, biodegradables y compostables haciendo realidad las ideas de nuestros clientes, generando la mayor satisfacción al proveerles las mejores soluciones  para sus negocios, sin olvidar nuestro compromiso con el entorno social , el medio ambiente y   Promoviendo el consumo responsable de productos de un solo uso y alineados  con economías verdes y sostenibles.' : 
	   						'Liderar el mercado venezolano en el área de productos ecológicos amigables 100% con el medio ambiente que brinden soluciones integrales en publicidad y comunicación visual . Con un dinámico enfoque, capaz de generar propuestas de alta calidad, comprometida con las más exigentes expectativas y conformadas por un equipo humano de vanguardia generando alternativas que se traducen en el éxito de nuestros clientes.'
	   					}
	   				</p>
	   			</Modal> 
	   		}

				<a className="prev" onClick={() => onPrevClick()}>&#10094;</a>
				<a className="next" onClick={() => onNextClick()}>&#10095;</a>
			<div className="dots-control text-center">
				<span className={`dot ${sliderShowing === 1 ? 'dot-active' : null}`} onClick={() => setSlider(1)}></span>
				<span className={`dot ${sliderShowing === 2 ? 'dot-active' : null}`} onClick={() => setSlider(2)}></span>
				<span className={`dot ${sliderShowing === 3 ? 'dot-active' : null}`} onClick={() => setSlider(3)}></span>
				<span className={`dot ${sliderShowing === 4 ? 'dot-active' : null}`} onClick={() => setSlider(4)}></span>
				<span className={`dot ${sliderShowing === 5 ? 'dot-active' : null}`} onClick={() => setSlider(5)}></span>
				<span className={`dot ${sliderShowing === 6 ? 'dot-active' : null}`} onClick={() => setSlider(6)}></span>
				<span className={`dot ${sliderShowing === 7 ? 'dot-active' : null}`} onClick={() => setSlider(7)}></span>
				<span className={`dot ${sliderShowing === 8 ? 'dot-active' : null}`} onClick={() => setSlider(8)}></span>
				<span className={`dot ${sliderShowing === 9 ? 'dot-active' : null}`} onClick={() => setSlider(9)}></span>
				<span className={`dot ${sliderShowing === 10 ? 'dot-active' : null}`} onClick={() => setSlider(10)}></span>
			</div>
	   </div>
	)
};